import React from "react";
import { inject } from "mobx-react";

import ImageComponent from "./ImageComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import { FILE_UPLOAD_MAX_LENGTH, IMAGE_TYPE, SHOW_TIME_MIDIA_DEFAULT, SHOW_TIME_MIDIA_MIN } from "~/configs/constants";
import { isEmptyOrNullStr, getVarFromUrl } from "../../helpers/utils";
import "share-api-polyfill";

@inject("ImageStore", "DeviceStore", "FileStore", "ProductStore", "FontStore", "PageStore", "OrganizationStore", "PreviewStore")
class ImageContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      image: {},
      searchText:"",
      selectedFiles: null,
      products:[],
    };
  }

  async componentDidMount() {
    await this.getImage();

    try {
      const { font } = this.state;
      document.getElementById("font").style.fontFamily = font.name;
    } catch{}
  }

  onFileChange = async event => {
    const { image } = this.state;
    const files = Array.from(event.target.files); // transforma em array
    const validFiles = [];

    for (const file of files) {
      const fileType = file.type;
      const fileSize = file.size;

      // valida tamanho
      if (fileSize > FILE_UPLOAD_MAX_LENGTH) {
        AlertComponent.error(`O arquivo ${file.name} excede o limite máximo de envio`);
        continue; // ignora esse arquivo
      }

      // valida formato
      if (
        (image.type === IMAGE_TYPE.image &&
          fileType !== "image/png" &&
          fileType !== "image/gif" &&
          fileType !== "image/bmp" &&
          fileType !== "image/jpeg") ||
        (image.type === IMAGE_TYPE.video &&
          fileType !== "video/mp4")
      ) {
        AlertComponent.error(`Formato não suportado: ${file.name}`);
        continue;
      }

      validFiles.push(file);
    }

    if (validFiles.length === 0) {
      document.getElementById("uploadCaptureInputMidia").value = "";
      this.setState({ selectedFiles: [] });
      return;
    }

    // armazena todos os válidos
    this.setState({ selectedFiles: validFiles }, () => {
      this.preview();
    });
  };

  getImage = async () => {
    this.setState({
      isLoading: true,
    });

    const { ImageStore, DeviceStore, history } = this.props;
    let pageId = getVarFromUrl("pageId");
    let deviceId = getVarFromUrl("deviceId");
    const imageId = getVarFromUrl("imageId");    
    const hasImage = imageId !== undefined && parseInt(imageId) > 0;    
 
    await DeviceStore.setDeviceId(deviceId);
    let device = await DeviceStore.getDevice();

    let image = {};
    if (!hasImage){
      image.imageId = 0;
      image.deviceId = deviceId;
      image.pageId = pageId;
      image.type = IMAGE_TYPE.image;
      image.showTime = SHOW_TIME_MIDIA_DEFAULT;
    }
    else {
      image = await ImageStore.getImage(imageId);
      if (image === undefined || image === null){
        history.push("devices");
        return;
      }
      pageId = image.pageId;
      deviceId = image.deviceId;
    }
    
    if (image.name === undefined || image.name === null) image.name = "";

    this.setState({
      isLoading: false,
      device,
      image
    });
    this.preview();
  };

  goDevice = () => {
    const { history } = this.props;
    history.push(`page?deviceId=${getVarFromUrl("deviceId")}&pageId=${getVarFromUrl("pageId")}&tab=${getVarFromUrl("tab")}`);
  };

  maintainImage = async () => {
    this.setState({
      isLoading: true
    });

    const { image, selectedFiles } = this.state;
    const { ImageStore } = this.props;

    if (isEmptyOrNullStr(image.showTime) || image.showTime < SHOW_TIME_MIDIA_MIN) AlertComponent.error("Tempo de exibição da mídia deve ser maior ou igual a " + SHOW_TIME_MIDIA_MIN + " segundos");
    else if (isEmptyOrNullStr(image.type) || (image.type !== IMAGE_TYPE.image && image.type !== IMAGE_TYPE.video)) AlertComponent.error("Nenhum tipo de mídia selecionado");
    else if (image.imageId === undefined && selectedFiles == null) AlertComponent.error("Nenhum arquivo selecionado");
    else {      
      if (selectedFiles !== undefined && selectedFiles !== null && selectedFiles.length > 0) {
        for (const file of selectedFiles) {   
          const formData = new FormData();
          image.name = file.name;
          formData.append("payload", JSON.stringify(image));       
          formData.append(file.name, file);
          const result = await ImageStore.maintainImage(formData);

          if (result === "") {
            AlertComponent.success(`Mídia ${file.name} salva(s) com sucesso`);
          }
          else {
            AlertComponent.success(`Falha o salvar mídia ${file.name}`);
          }
        }
      }
      else {
        const formData = new FormData();
        formData.append("payload", JSON.stringify(image));
        const result = await ImageStore.maintainImage(formData);

        if (result === "") {
          AlertComponent.success('Mídia salva com sucesso');
        }
        else {
          AlertComponent.success('Falha ao salvar mídia');
        } 
      }

      this.goDevice();
    }

    this.setState({
      isLoading: false
    });
  };

  onChange = async (e) => {
    const { image } = this.state;
    const updatedImage = {
      ...image,
      [e.target.name]: e.target.value     
    }

    this.setState({
      image: updatedImage
    });
    this.preview();
  };

  preview = async () => {
    try {
      setTimeout(() => {
        const { image, selectedFiles } = this.state;
        let files = [];

        if (selectedFiles && selectedFiles.length > 0) {
          files = selectedFiles.map(file => ({
            name: file.name,
            url: URL.createObjectURL(file)
          }));
        } else if (image?.path) {
          // fallback se não tiver arquivo novo, mas tiver caminho antigo
          files = [{ name: image.name || "arquivo", url: image.path }];
        }

        this.setState({ files });

        // Ajustes visuais (se quiser aplicar a todos previews)
        files.forEach((file, index) => {
          const img = document.getElementById(`imagePreview-${index}`);
          if (img) {
            img.style.width = "100%";
            img.style.height = "400px";
            img.style.objectFit = "contain";
          }

          const video = document.getElementById(`videoPreview-${index}`);
          if (video) {
            video.style.width = "100%";
            video.style.height = "400px";
            video.style.objectFit = "contain";
          }
        });
      }, 500);
    } catch {}
  };

  render() {
    const { isLoading, image, files } = this.state;
    return (
      <>
        {(isLoading && (
          <>
            <LoadingComponent />
          </>
        )) || (
          <div className="content content-xs" style={{overflow: "hidden"}} >
            <ImageComponent
              onChange={this.onChange}
              onClick={this.maintainImage}
              onCancel={this.goDevice}              
              onFileChange={this.onFileChange}
              image={image}
              files={files}
            />            
          </div>
        )}
      </>
    );
  }
}

export default ImageContainer;